import { LocationRequest } from '@pxtra-client-lib-legacy/gen';
import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { useStore } from '../../../../../hooks/useStore';
import { DataViewEditBox, useForm } from '../../../../../lib/components';
import { CostCenterDataForm } from './form';

export const CostCenterData = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { companyStore } = useStore();
  const params = useParams();
  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const form = useForm();

  const renderEdit = () => {
    return (
      <CostCenterDataForm
        initialValues={{
          name: companyStore.costCenters?.filter((c) => c.id === params.costCenterId)[0]?.name || ''
        }}
        formRef={form.formRef}
        onStateChanged={setCanSubmit}
        onSubmit={async (values) => {
          try {
            if (params.costCenterId === 'new') {
              await companyStore.createCostCenter(values as LocationRequest);
              navigate(-1);
            } else if (params.costCenterId) {
              await companyStore.updateCostCenterData(params.costCenterId, values);
            }
          } catch (error) {
            console.error(error);
          }
        }}
        useCustomButton
      />
    );
  };

  useEffect(() => {
    const abortController = new AbortController();

    const fetchCostCenters = async () => {
      if (companyStore.costCenters && companyStore.costCenters?.length > 0) return;
      try {
        await companyStore.fetchCostCenters();
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error(error);
        }
      }
    };
    fetchCostCenters();

    return () => abortController.abort();
  }, [companyStore.company?.id]);

  return (
    <DataViewEditBox
      title={t('company:COST_CENTER', {
        context: params.costCenterId === 'new' ? 'new' : undefined
      })}
      view={() => <></>}
      edit={renderEdit}
      canEdit={params.costCenterId !== 'new'}
      initMode={'edit'}
      canSubmit={canSubmit}
      onSubmit={() => {
        form.handleSubmit();
        navigate(-1);
      }}
      onCancel={() => {
        form.handleReset();
        navigate(-1);
      }}
    />
  );
});
